import { createFileRoute, redirect } from '@tanstack/react-router'
import { KelolaStaff } from '../../../../components/KelolaStaff'

export const Route = createFileRoute('/desa/$slug/dashboard/staff')({
  beforeLoad: ({ context, params }: any) => {
    const user = (context as any)?.user
    if (user?.role === 'operator_desa') {
      throw redirect({ to: `/desa/${params.slug}/dashboard` as any })
    }
  },
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <KelolaStaff desaId={desaId} />
  },
})
